import {
  Heading,
  Highlight,
  Box,
  Text,
  type BoxProps,
  type HeadingProps,
  type SystemStyleObject,
  type TextProps,
} from "@chakra-ui/react";
import React from "react";

interface WithHeading4Props {
  children: React.ReactNode;
  query?: string[];
  styles?: SystemStyleObject;
  size?: HeadingProps["size"];
  pt?: BoxProps["pt"];
  textAlign?: BoxProps["textAlign"];
  color?: TextProps["color"];
  fontWeight?: HeadingProps["fontWeight"];
}

export default function WithHeading4({
  children,
  query = [],
  styles = {
    px: "0.5",
  },
  size = { base: "sm", md: "md" },
  pt = { base: "1", md: "2" },
  textAlign = { base: "center", md: "left" },
  color = "moveon.publicFont",
  fontWeight = "semibold",
}: WithHeading4Props) {
  const highlightStyles: SystemStyleObject = { ...styles, color };

  return (
    <Box pt={pt} textAlign={textAlign}>
      <Heading as="h4" size={size} fontWeight={fontWeight} mb="1">
        {query.length > 0 ? (
          <Text as="span" color={color}>
            <Highlight query={query} styles={highlightStyles}>
              {String(children)}
            </Highlight>
          </Text>
        ) : (
          <Text as="span" color={color}>
            {children}
          </Text>
        )}
      </Heading>
    </Box>
  );
}
